import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";

const DigitalContentTerms = () => {
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.300");

  const sections = [
    {
      title: "디지털 콘텐츠 유통 약관",
      content: `플레이리스트 플래닛(이하"플플")을 운영하는 "주식회사 루나르트"(이하 "루나르트"라 한다)와 "권리자"는 다음과 같이 콘텐츠 유통을 진행하고 다음 사항에 동의한다.`,
    },
    {
      title: "제1조 (목적)",
      content: `본 동의서의 목적은 "권리자"가 기획/제작/유통하는 콘텐츠를 "루나르트"가 동의 기간 동안 동의 지역 내에서 독점적으로 제작/유통/배급/판매 등을 함에 있어 "권리자"와 "루나르트" 상호 간의 권리와 의무를 명확히 규정하는 데 있다.`,
    },
    {
      title: "제2조 (용어의 정의)",
      content: `1. "콘텐츠"라 함은 "권리자"가 저작권, 저작인접권 또는 퍼블리시티권 등(아티스트의 초상권, 성명권, 음성권 등을 포함)을 기보유 하고 있는 권리 및 동의 기간 중 취득하게 될 권리뿐만 아니라, 제3자로부터 "권리자"가 이용 허락 또는 처분을 할 수 있는 권한 일체를 허여 받았거나, 동의 기간 중 받게 될 음원, 음성, 초상, 자켓 이미지, 뮤직비디오를 포함한 동영상 (티져(TEASER) 영상 등 홍보, 프로모션 등을 목적으로 "권리자"가 기획, 제작하는 일체의 영상을 포함) 등 본 동의에 따라 "루나르트"가 "권리자"으로 부터 제공받는 모든 형태의 데이터를 말한다.
2. "디지털 음원"이라 함은 "권리자"가 기획, 제작 혹은 유통하는 콘텐츠가 디지털 형태로 전송, 복제, 저장되는 전자적 표시를 말하며, 파일의 형태는 불문한다.
3. "발매"라 함은 온라인 상으로 새로이 제작된 콘텐츠의 유통을 시작하는 행위를 말한다.
4. "수익사업"이라 함은 콘텐츠의 저작인접권을 활용하여 "루나르트"가 직접 또는 제3자를 통하여 본 동의서 목적 범위 내에서 수정, 변경, 복제, 판매, 배포, 전송, 방송, 대여 및 이를 포함한 유통사업 등 가능한 모든 방식을 이용한 각종 서비스를 기획하여 수익을 창출하고 관리하는 행위를 의미한다.
5. "유통 수익"이라 함은 "루나르트"가 "권리자"을 통하여 창출한 모든 수익을 의미한다.
6. "유통 수수료"라 함은 본 동의서 콘텐츠의 유통 시 그 업무의 대가로 "루나르트"에게 지불되는 금액을 말한다.
7. "인세"라 함은 본 동의서 콘텐츠의 발매를 통해 실제 수령한 매출액 중 "루나르트"의 유통 수수료, 각 해외 서비스 사업자의 수수료, 각 지역에 따라 발생할 수 있는 국가별 원천징수 및 세금, 저작권료, 실연권료 등의 비용을 공제한 후 "루나르트"가 "권리자"에게 지급하여야 할 금액을 말한다.
8. 본 동의서에서 정의된 용어의 적용 범위는 본 동의서에 한하며, 정의되지 않은 용어의 해석은 저작권법을 포함한 관련 법령 및 일반 관례에 따른다.`,
    },
    {
      title: "제3조 (대상 콘텐츠)",
      content: `1. 본 동의에 따라 "권리자"가 "루나르트"에게 독점적 유통권을 부여한 대상 콘텐츠는 "권리자"가 저작인접권, 유통권 등의 권리를 소유하거나 위임/위탁 받아 "루나르트"에게 제공하는 모든 콘텐츠(이하 "유통 콘텐츠")이다.
2. "권리자"는 동의서 동의 이후 "루나르트"에게 이메일 등의 서면 통지를 통해 유통 콘텐츠를 변경할 수 있으며, 상기 콘텐츠는 본 동의서와 동일한 조건으로 귀속된다.`,
    },
    {
      title: "제4조 (동의 기간)",
      content: `1. 본 동의 유효기간은 제출일로부터 3년으로 한다. 단, 동의 만료 30일 이전 별도의 서면 합의가 없을 시, "본 동의"는 3년 단위로 자동 연장한다.
2. 동의 기간 동안 양자간 서면에 의한 동의 종료 합의가 있는 경우에는 합의 후 30일이 경과한 날이 속한 달의 말일에 동의가 종료된다. 단, 동의가 종료되어도 유통 콘텐츠에서 발생한 유통 수익에 대해 "루나르트"는 "권리자"에게 정산 및 배분해야 할 의무가 있고, 동의 기간 종료 후에도 "루나르트"는 "권리자"가 유통 계약을 체결한 제3자의 유관 업무 요청에 대해 성실히 협조하기로 한다.`,
    },
    {
      title: "제5조 (효력 범위)",
      content: `1. 본 동의는 대한민국 및 전 세계에 대하여 적용한다. 단, 특정 콘텐츠의 국가 제한이 있을 경우 "권리자"는 "루나르트"에게 이를 고지하며, 해당 방식은 별도 협의한다.
2. "루나르트"는 동의 기간 동안 국·내외 플랫폼에 대한 독점적 디지털 음원 및 뮤직비디오의 유통권을 가지며, 유통 서비스의 범위는 "루나르트"가 정기적으로 작성하는 저작물관리목록 범위에 의한다.`,
    },
    {
      title: "제6조 (각 당사자의 권리와 의무 및 보증사항)",
      content: `1. "루나르트"는 동의 기간 중 제5조에서 정한 범위 내에서 "루나르트"의 상호로 콘텐츠를 유통할 수 있는 배타적이고 독점적인 권리를 가지며, "권리자"는 제3자와 제5조에서 정한 본 동의 효력 범위와 중복되는 유통 계약을 체결할 수 없다.
2. "권리자"는 콘텐츠가 적법하고 정당하게 제작 혹은 유통하고 있음을 확인 보증하며, 콘텐츠에 대한 초상권, 퍼블리시티권, 저작권 및 저작인접권 등과 관련되어 제3자로부터의 침해 주장 등 법적 분쟁이 발생할 경우, "권리자"의 노력과 비용으로 "루나르트"을 면책시키며, 제3자로부터의 사용료 청구 또는 기타 이의나 소송의 제기가 있을 때에도 전적으로 "권리자"가 책임을 진다. 또한 이로 인하여 "루나르트"에게 손해가 발생할 경우 "권리자"는 이에 대한 손해액 및 분쟁과 관련되어 "루나르트"에게 발생한 일체의 비용을 "루나르트"에게 배상하여야 한다.
3. 본 조 전항에 따른 분쟁이 해결될 때까지 "루나르트"는 "권리자"에 대하여 제7조에 따른 정산 절차를 중지할 수 있다.
4. "권리자"는 "루나르트"의 원활한 수익사업을 위해 자료(인쇄물, 이미지 파일, 뮤직비디오, 음원 등)를 제공하여야 하며, "루나르트"는 이를 대가 없이 이용할 수 있다. 이를 위하여 제3자의 이용허락 등 선행조치가 필요할 경우, "루나르트"의 권리 행사에 장애가 없도록 "권리자"는 이를 위해 필요한 모든 조치를 사전에 취하여야 하며, 기타 동의 목적 범위 내에서 필요한 "루나르트"의 요구사항에 적극 협조하여야 한다.
5. "루나르트"는 본 동의에 의해 취득한 권리의 범위 내에서 수익사업을 제3자에게 대행시킬 수 있으며, 범위를 정하여 콘텐츠의 이용/유통/배급/판매 등을 제3자에게 재허락 할 수 있다.
6. "루나르트"는 본 동의 기간 동안 콘텐츠를 적법하게 이용할 수 있는 권리를 보유하였거나 그러한 동의 관계가 유효함을 보증한다.
7. "권리자"는 본 동의와 관련하여 위법 사항이나 소송, 국세 체납 사실 등의 법적 문제가 없음을 보증한다.`,
    },
    {
      title: "제7조 (수익 배분)",
      content: `1. "루나르트"는 다음의 기준에 따라 수익사업과 관련하여 발생한 유통 수익을 "권리자"와 상호 배분하고 매월 정산하여 익월 말까지 인세를 정산하여 "권리자"가 지정한 계좌에 현금으로 지급한다. (단, 첫 정산은 서비스 개시 후 (국내) 만 2개월, (국외) 만 3개월 이후부터 정산하기로 한다.)
2. "루나르트"는 이 콘텐츠 발매를 통하여 실제 수령한 누적 매출액 중 유통수수료로 10% (부가가치세 포함)를 지급받기로 한다.
3. 본 동의서에 명시되지 않은 사항에 대해서는 쌍방의 협의를 거친 후 별도의 부속 약정을 체결하여 변경, 조정할 수 있다.
4. "권리자"는 전항에 따른 유통 수익 내역에 이의가 없을 경우 "루나르트"가 안내한 날짜 내에 세금계산서를 발행하며, 세금계산서를 발행하지 않을 경우는 원천징수처리 하기로 한다. 단, "권리자"가 연락 두절 등의 사정으로 인하여 정산 요청을 할 수 없을 경우에는 "루나르트"는 "권리자"의 소재가 파악될 때까지 정산 금액을 지급하지 아니하고 보관할 수 있으며, 이 때 보관된 정산 금액에 대하여는 이자를 지급하지 아니한다.
5. 콘텐츠 수익에 대한 "권리자"의 유통 수수료율 등은 본 조 2항에서 정하는 바와 같으며, "루나르트"가 수익 사업을 통해 제휴사, 음원 서비스사 또는 해외 에이전시 등 콘텐츠를 이용한 제3자들로부터 최종 정산 받는 금액에서 "외화 환전수수료" 및 "루나르트"의 "유통 수수료"를 제한 금액을 "권리자"에 지급하기로 한다.
6. 본 조에 따른 수익 배분의 현금이 외화(미화)일 경우 적용 환율은 "루나르트" 정산일의 환율을 기준으로 한다.
7. 본 조에 따른 정산 절차에 있어 관계법령에 따라 세금계산서를 발행해야 하는 경우, 부가가치세를 별도로 하며, 정산 절차는 양자 합의하에 변경할 수 있다.`,
    },
    {
      title: "제8조 (동의 해제 및 해지 등)",
      content: `1. "권리자"와 "루나르트"는 다음 각 호 중 어느 하나에 해당하는 경우 상대방에 대한 서면 통지를 통해 즉시 해제 또는 해지할 수 있다.
1) 일방 당사자가 본 동의 조항을 위반하고 상대방이 서면으로 그 시정을 요구하였음에도 불구하고 10일 이내에 이행하지 아니할 때
2) "권리자"와 유통 콘텐츠의 제작에 참여한 아티스트 사이에서 발생한 분쟁, 유통 콘텐츠의 제작에 참여한 아티스트 간의 분쟁 등 "권리자"의 사유로 인해 유통 콘텐츠의 발매, 홍보 업무를 수행하는 것이 더 이상 불가능하다고 "루나르트"가 판단하는 경우
3) 본 동의서 동의 전에 계약/발매하였던 콘텐츠로 인하여 "권리자"와 유통 콘텐츠의 제작에 참가한 실연자, "권리자"와 "권리자" 소속의 제3의 아티스트 또는 "권리자"와 제3의 유통사와 분쟁 등이 발생한 결과로 유통 콘텐츠과 관련된 소송 제기 등의 사유가 발생함으로써 유통 콘텐츠의 발매 또는 더 이상의 제작/유통/배급/판매가 어렵거나 불가능하다고 "루나르트"가 판단하는 경우
4) 일방 당사자의 부도, 파산 영업상 주요 재산에 대한 압류/가압류/가처분/강제집행 기타 파산신청, 회생절차 개시신청 등 이와 유사한 재산 상태 악화가 발생하거나 그럴 우려가 있다고 인정할 만한 이유가 있을 때
5) 일방 당사자의 영업의 폐지, 변경, 또는 해산의 결의가 있을 때
2. 천재지변, 전쟁, 노사분규, 화재, 정부 규제 등 신속히 해결할 수 없는 문제가 발생하였을 경우에는 그러한 사태가 해소된 이후 최소한 24시간 이내에 동의한 상대방에게 통지하여야 하며, 이러한 상황이 30일 이상 계속되어 본 동의 이행이 불가능하게 될 것으로 예상되는 경우, 동의서 내용은 자동적으로 해지되는 것으로 한다.`,
    },
    {
      title: "제9조 (손해배상)",
      content: `동의서 해지 또는 해제는 손해배상 청구에 영향을 미치지 아니하며 본 동의를 위반한 일방 당사자는 상대방에게 발생한 모든 손해에 대하여 배상할 책임이 있다.`,
    },
    {
      title: "제10조 (비밀 유지)",
      content: `양 당사자는 본 동의서 동의 및 이행으로 취득한 상대방의 업무상 비밀에 대하여 동의 기간 및 동의 종료일 이후 3년간 상대방의 사전 서면 동의 없이는 제3자에게 유출하거나 다른 목적에 사용하지 아니 한다.`,
    },
    {
      title: "제11조 (양도 금지)",
      content: `양 당사자는 상대방의 사전 서면 동의 없이는 본 동의에서 "루나르트"가 취득하게 되는 저작인접권, 독점적인 유통권 및 이를 관리할 수 있는 관리수익권 등을 본 동의상의 권리 및 의무의 전부 또는 일부를 제3자에게 양도, 위임하거나 담보 제공 등의 목적으로 처분할 수 없으며, 이를 위반하는 것은 중대한 동의위반행위를 구성한다. 단, "루나르트"가 본 동의서 제6조에 의해 "권리자"로 부터 제공받은 권리에 근거하여 권리를 제3자에게 대행시키거나 재허락 하는 경우는 제외한다.`,
    },
    {
      title: "제12조 (분쟁의 해결 및 합의 관할)",
      content: `본 동의와 관련된 분쟁은 상호 협의와 일반 상거래 관행에 의거하여 해결하되 그에 따라 해결되지 않을 경우의 소송 관할은 "루나르트"의 소재지 관할법원으로 하기로 한다.`,
    },
  ];

  return (
    <Box bg={bgColor} minH="100vh" py={8}>
      <Container maxW="container.lg">
        <VStack align="start" spacing={8}>
          <Heading as="h1" size="lg" mb={6}>
            디지털 콘텐츠 유통 약관
          </Heading>

          {sections.map((section, index) => (
            <Box key={index} width="100%">
              <Heading as="h2" size="sm" mb={4}>
                {section.title}
              </Heading>
              <Text
                color={textColor}
                whiteSpace="pre-line"
                mb={8}
                fontSize="sm"
              >
                {section.content}
              </Text>
            </Box>
          ))}
        </VStack>
      </Container>
    </Box>
  );
};

export default DigitalContentTerms;
